(() => {
  if (window.__phoneSupportStatusLoaded) return;
  window.__phoneSupportStatusLoaded = true;

  const DAY_INDEX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  const parseTime = (value, fallback) => {
    const match = /^(\d{1,2}):(\d{2})$/.exec((value || '').trim());
    return match ? Number(match[1]) * 60 + Number(match[2]) : fallback;
  };

  const nowInTimezone = (timeZone) => {
    const options = { hour12: false, weekday: 'short', hour: '2-digit', minute: '2-digit' };
    let parts;
    try {
      parts = new Intl.DateTimeFormat('en-US', { ...options, timeZone }).formatToParts(new Date());
    } catch (e) {
      parts = new Intl.DateTimeFormat('en-US', options).formatToParts(new Date());
    }
    const get = (type) => (parts.find((p) => p.type === type) || {}).value;
    return {
      day: DAY_INDEX[get('weekday')],
      minutes: ((Number(get('hour')) % 24) * 60) + Number(get('minute')),
    };
  };

  const update = () => {
    document.querySelectorAll('.phone-support[data-auto-status]').forEach((el) => {
      const now = nowInTimezone(el.dataset.tz || 'Europe/Berlin');
      const dayFrom = Number(el.dataset.dayFrom);
      const dayTo = Number(el.dataset.dayTo);
      const dayOpen =
        dayFrom <= dayTo
          ? now.day >= dayFrom && now.day <= dayTo
          : now.day >= dayFrom || now.day <= dayTo;
      const opensAt = parseTime(el.dataset.open, 9 * 60);
      const closesAt = parseTime(el.dataset.close, 17 * 60);
      const isOpen = dayOpen && now.minutes >= opensAt && now.minutes < closesAt;
      el.classList.toggle('phone-support--closed', !isOpen);
    });
  };

  update();
  setInterval(update, 60 * 1000);
  document.addEventListener('shopify:section:load', update);
})();
